var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMailIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 14,
  fill: "none",
  viewBox: "0 0 16 14",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#0F8491",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M15.5 2.5c0-.825-.675-1.5-1.5-1.5H2C1.175 1 .5 1.675.5 2.5m15 0v9c0 .825-.675 1.5-1.5 1.5H2c-.825 0-1.5-.675-1.5-1.5v-9m15 0L8 7.75.5 2.5"
})));
export { SvgMailIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/mailIcon.svg";